// src/components/Asuran.js
import React from 'react';
import "./Asuran.css"

function Asuran() {
  return (
    <section className="asuran">
      <h2>हमरी चाट की दुकान, तोहरे गोरखपुर की शान!</h2>
      <p>
        We are located at Ramgarh Taal, Gorakhpur since your dada-pardada's time.
        <p>Ph: +91 8299123339; email: dhannobannokirasoi@gmail.com</p>
      </p> 
      <h3>
      जो अइहो अ खइहो त चाट चाट के बउरा जइहो!
      </h3>
      {/* Possibly an image or more details */}
    </section>
  );
}

export default Asuran;
